import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Icon } from '@iconify/react';

interface CreateCompanyHeaderProps {
  onCancel: () => void;
  isLoading?: boolean;
}

export function CreateCompanyHeader({ onCancel, isLoading = false }: CreateCompanyHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex items-center justify-between">
      <h1 className="text-2xl font-bold">{t('company.create.title') || 'Create Company'}</h1>
      <Button
        variant="outline"
        onClick={onCancel}
        disabled={isLoading}
      >
        <Icon icon="mdi:close" className="h-4 w-4 mr-2" />
        {t('common.cancel')}
      </Button>
    </div>
  );
}

